import React from "react";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import StarsIcon from "@mui/icons-material/Stars";
import { getEventHeaderTitle } from "@Modules/eventPage/utils/getEventHeaderTitle";
import commonStyles from "../commonStyles.module.scss";
import moduleStyles from "./Style.module.scss";
import useTrustIcons from "./useTrustIcons";

const TrustIcons = () => {
    const { hideTrustmarkerIcons, eventData } = useTrustIcons();

    if (hideTrustmarkerIcons === true) return null;
    return (
        <div className={commonStyles.detailsSection}>
            <div className={`row `}>
                <div
                    className={`col-4 m-auto text-center ${moduleStyles.borderRight} ${moduleStyles.item}`}
                >
                    <VerifiedUserOutlinedIcon
                        className={moduleStyles.icon}
                        fontSize="medium"
                    />
                    <div className={`${moduleStyles.text} mt-1`}>
                        Trusted creator
                    </div>
                </div>
                <div
                    className={`col-4 m-auto text-center ${moduleStyles.borderRight} ${moduleStyles.item}`}
                >
                    <InsightsOutlinedIcon
                        className={moduleStyles.icon}
                        fontSize="medium"
                    />
                    <div className={`${moduleStyles.text} mt-1`}>
                        Popular {getEventHeaderTitle({ eventData })}
                    </div>
                </div>
                <div
                    className={`col-4 m-auto text-center ${moduleStyles.item} `}
                >
                    <StarsIcon
                        className={moduleStyles.icon}
                        fontSize="medium"
                    />
                    <div className={`${moduleStyles.text} mt-1`}>
                        Good feedback
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrustIcons;
